import { render } from "./RegistrationListFieldComponent.vue?vue&type=template&id=5a75ccf6&scoped=true"
import script from "./RegistrationListFieldComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationListFieldComponent.vue?vue&type=script&lang=js"

import "./RegistrationListFieldComponent.vue?vue&type=style&index=0&id=5a75ccf6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a75ccf6"]])

export default __exports__